export default {"src":"/_next/static/media/dining.a260b56e.svg","height":65,"width":116,"blurWidth":0,"blurHeight":0};